import { PAGES } from "#/constants";
import {
  ADD_DEPENDENT_BREADCRUMP,
  COMPLEMENTARY_DATA_BREADCRUMP,
  CONTACT_BREADCRUMP,
  CONTRACT_BREADCRUMP,
  DEPENDENTS_BREADCRUMP,
  DETAILS_PLAN_BREADCRUMP,
  MY_PLAN_BREADCRUMP,
  NEW_DEPENDENTS_BREADCRUMP,
  PAYMENT_BREADCRUMP,
  PLANS_BREADCRUMP,
} from "./constants";
import { BreadcrumbPropsConfig } from "./types";

export const BREADCRUMPS_CONFIG: BreadcrumbPropsConfig = {
  [PAGES.PLANS]: PLANS_BREADCRUMP,
  [PAGES.MY_PLAN]: (typePlan) => MY_PLAN_BREADCRUMP(typePlan),
  [PAGES.CONTACT]: (typePlan) => CONTACT_BREADCRUMP(typePlan),
  [PAGES.CONTRACT]: (typePlan) => CONTRACT_BREADCRUMP(typePlan),
  [PAGES.DEPENDENTS]: (typePlan) => DEPENDENTS_BREADCRUMP(typePlan),
  [PAGES.ADD_DEPENDENT]: ADD_DEPENDENT_BREADCRUMP,
  [PAGES.NEW_DEPENDENTS]: (typePlan) => NEW_DEPENDENTS_BREADCRUMP(typePlan),
  [PAGES.PAYMENT]: (typePlan) => PAYMENT_BREADCRUMP(typePlan),
  [PAGES.DETAILS_PLAN]: (typePlan) => DETAILS_PLAN_BREADCRUMP(typePlan),
  [PAGES.COMPLEMENTARY_DATA]: (typePlan) =>
    COMPLEMENTARY_DATA_BREADCRUMP(typePlan),
};
